/**
 * Formats doctor name with proper title handling to avoid duplication
 * @param {Object} doctor - Doctor object with title, firstName, and lastName
 * @returns {string} - Formatted doctor name
 */
export const formatDoctorName = (doctor) => {
  if (!doctor) return "--";
  
  const title = doctor.title || "Dr.";
  const firstName = (doctor.firstName || "").trim();
  const lastName = (doctor.lastName || "").trim();
  const fullName = `${firstName} ${lastName}`.trim();
  
  // Return dash if no name available
  if (!fullName) return "--";
  
  // Check if the name already starts with Dr. to avoid duplication
  if (fullName.toLowerCase().startsWith('dr.') || fullName.toLowerCase().startsWith('doctor')) {
    return fullName;
  }
  
  return `${title} ${fullName}`.trim();
};

/**
 * Formats doctor name for display in UI components
 * @param {Object} doctor - Doctor object with title, firstName, and lastName
 * @returns {string} - Formatted doctor name or fallback
 */
export const formatDoctorDisplayName = (doctor, fallback = "-") => {
  if (!doctor) return fallback;
  
  const formatted = formatDoctorName(doctor);
  return formatted === "--" ? fallback : formatted;
}; 